import {get} from 'utils/helper'

export const setMetadataInfo = data => {
  const oldSupport = JSON.parse(window.localStorage.getItem('support') || '{}')
  window.localStorage.setItem('support', JSON.stringify({...oldSupport, accountMetadata: data}))
}

export const getMetadataInfo = () => {
  return get(['accountMetadata' || '{}'], JSON.parse(window.localStorage.getItem('support')))
}

export const getRouteState = () => {
  return get(['routeState' || '{}'], JSON.parse(window.localStorage.getItem('support')))
}

export const setRouteState = data => {
  const oldSupport = JSON.parse(window.localStorage.getItem('support') || '{}')
  window.localStorage.setItem('support', JSON.stringify({...oldSupport, routeState: data}))
}

export const getUserInfo = () => {
  return get(['userInfo' || '{}'], JSON.parse(window.localStorage.getItem('support')))
}

export const setUserInfo = data => {
  const oldSupport = JSON.parse(window.localStorage.getItem('support') || '{}')
  window.localStorage.setItem('support', JSON.stringify({...oldSupport, userInfo: data}))
}
export const setDomainInfo = data => {
  const oldSupport = JSON.parse(window.localStorage.getItem('support') || '{}')
  window.localStorage.setItem('support', JSON.stringify({...oldSupport, domain: data}))
}

export const getAccountInfo = () => {
  return get(['accountInfo' || '{}'], JSON.parse(window.localStorage.getItem('support')))
}

export const setAccountInfo = data => {
  const oldSupport = JSON.parse(window.localStorage.getItem('support') || '{}')
  window.localStorage.setItem('support', JSON.stringify({...oldSupport, accountInfo: data}))
}

export const getRoleInfo = () => {
  return get(['roleInfo' || '{}'], JSON.parse(window.localStorage.getItem('support')))
}

export const setRoleInfo = data => {
  const oldSupport = JSON.parse(window.localStorage.getItem('support') || '{}')
  window.localStorage.setItem('support', JSON.stringify({...oldSupport, roleInfo: data}))
}

export const getProfilePicColor = () => {
  return get(['profilePicColor' || '{}'], JSON.parse(window.localStorage.getItem('support')))
}

export const setProfilePicColor = data => {
  const oldSupport = JSON.parse(window.localStorage.getItem('support') || '{}')
  window.localStorage.setItem('support', JSON.stringify({...oldSupport, profilePicColor: data}))
}

export const getAppToken = () => {
  return get(['veemoToken'], JSON.parse(window.localStorage.getItem('support')))
}

export const setAppToken = data => {
  const oldSupport = JSON.parse(window.localStorage.getItem('support') || '{}')
  window.localStorage.setItem('support', JSON.stringify({...oldSupport, veemoToken: data}))
  // window.localStorage.setItem(process.env.REACT_APP_TOKEN_NAME, data)
}

export const getRememberMe = () => {
  return get(['rememberMe' || '{}'], Boolean(window.localStorage.getItem('support')))
}

export const setRememberMe = data => {
  const oldSupport = JSON.parse(window.localStorage.getItem('support') || '{}')
  window.localStorage.setItem('support', JSON.stringify({...oldSupport, rememberMe: data}))
}

export const getCurrentLayout = () => {
  return get(['currentLayout' || '{}'], JSON.parse(window.localStorage.getItem('support')))
}

export const setCurrentLayout = data => {
  const oldSupport = JSON.parse(window.localStorage.getItem('support') || '{}')
  window.localStorage.setItem('support', JSON.stringify({...oldSupport, currentLayout: data}))
}

export const getLastActivity = () => {
  return get(['lastActivity' || '{}'], JSON.parse(window.localStorage.getItem('support')))
}

export const setLastActivity = data => {
  const oldSupport = JSON.parse(window.localStorage.getItem('support') || '{}')
  window.localStorage.setItem('support', JSON.stringify({...oldSupport, lastActivity: data}))
}

export const clearStorage = () => {
  window.localStorage.removeItem('support')
}
